module.exports = __webpack_public_path__ + "static/media/backMediumLarge.952afd54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/backMediumLarge.svg
// module id = 179
// module chunks = 0